var _defs, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFolder(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "tabGradient",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#ffd54f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#ffb300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bodyGradient",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#ffe082"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#ffca28"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "shadow",
    x: "-20%",
    y: "-20%",
    width: "140%",
    height: "140%"
  }, /*#__PURE__*/React.createElement("feOffset", {
    in: "SourceAlpha",
    dx: 0,
    dy: 2,
    result: "offOut"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "offOut",
    stdDeviation: 2,
    result: "blurOut"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blurOut",
    type: "matrix",
    values: "0 0 0 0 0  0 0 0 0 0  0 0 0 0 0  0 0 0 0.3 0",
    result: "matrixOut"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "matrixOut",
    mode: "normal"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#shadow)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 22 a2 2 0 0 1 2 -2 h18 l6 6 h26 a2 2 0 0 1 2 2 v20 a2 2 0 0 1 -2 2 H8 a2 2 0 0 1 -2 -2 V22 z",
    fill: "url(#bodyGradient)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 22 a2 2 0 0 1 2 -2 h18 l6 6 h26 v-4 a2 2 0 0 0 -2 -2 H32 l-6 -6 H8 a2 2 0 0 0 -2 2 v4 H6 z",
    fill: "url(#tabGradient)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    stroke: "#fff",
    strokeWidth: 1.5,
    opacity: 0.6,
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 14,
    y1: 36,
    x2: 50,
    y2: 36
  }), /*#__PURE__*/React.createElement("line", {
    x1: 14,
    y1: 42,
    x2: 50,
    y2: 42
  }), /*#__PURE__*/React.createElement("line", {
    x1: 14,
    y1: 48,
    x2: 50,
    y2: 48
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolder);
export default __webpack_public_path__ + "static/media/folder.b9612b77c385e17f74cdd47918ec1875.svg";
export { ForwardRef as ReactComponent };